export default "__VITE_ASSET__CHsCd6et__"